module.exports = __webpack_public_path__ + "static/media/fWebsitesMobile.17fc552d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/fWebsitesMobile.jpg
// module id = 852
// module chunks = 14